import {
  CustomFormReport,
  CustomFormReportType,
  SendEmailFormData
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  customFormReportType: CustomFormReportType;
  customFormReport: CustomFormReport;
  emailBody?: SendEmailFormData | null;
  smsBody?: any | null;
}

interface ResponseDataType {
  is_task_queued: boolean;

  // Available only if task wasn't queued
  status_id: number | null;
  email: any | null;
  sms: any | null;
  public_link_url: string;
  sent_to_be_viewed_at: string | null;
  viewed_at: string | null;
  sent_to_be_filled_at: string | null;
  filled_at: string | null;
  // ------------------------------------
}

export const sendCustomFormReportPublicLinkRequest = ({
                                                        token,
                                                        customFormReportType,
                                                        customFormReport,
                                                        emailBody,
                                                        smsBody,
                                                      }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-report/public-link/create-and-send`, {
    method: 'POST',
    token,
    body: {
      custom_form_report_type: customFormReportType,
      custom_form_report: customFormReport,
      email_body: emailBody,
      sms_body: smsBody,
    },
  });
};